export const normalizeStructureKey = (value = '') =>
  String(value).replace(/\s+/g, ' ').trim().toLowerCase();

export const toStructureKey = (value = '') => normalizeStructureKey(value).replace(/\s+/g, '-');

export const sortByOrderThenName = (a, b) =>
  (a.sort_order ?? 0) - (b.sort_order ?? 0) || String(a.name).localeCompare(String(b.name));

export const getOrCreate = (map, key, factory) => {
  if (!map.has(key)) map.set(key, factory());
  return map.get(key);
};
